"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var enhancedContent_1 = __importStar(require("./enhancedContent"));
var events_1 = __importDefault(require("./events"));
var cookies_1 = require("./utils/cookies");
var uuid_1 = require("uuid");
var logger_1 = require("./utils/logger");
var time_on_page_tracker_1 = __importDefault(require("./utils/time-on-page-tracker"));
var version_1 = require("./version");
var sessionIdKey = 'salsify_session_id';
var defaultOptions = {
    languageCode: 'en-US',
    tracking: true,
};
var defaultEcSettings = {
    idType: 'SDKID',
};
/**
 * The Salsify Experiences SDK.
 *
 * This class is responsible for initializing the SDK and exposing the public getter methods for each different available API.
 */
var SdkApi = /** @class */ (function () {
    /** @internal */
    function SdkApi() {
        this._initialized = false;
    } // eslint-disable-line @typescript-eslint/no-empty-function
    /**
     * Initializes the SDK.
     *
     * Usage:
     ```javascript
     window.salsifyExperiencesSdk.init({ clientId, enhancedContent: { idType }})
     ```
     * @param options The options to initialize the SDK with.
     */
    SdkApi.prototype.init = function (options) {
        if (this._initialized) {
            throw new Error('Salsify Experiences SDK has already been initialized.');
        }
        var ecSettings = __assign(__assign({}, defaultEcSettings), options.enhancedContent);
        this.settings = __assign(__assign(__assign({}, defaultOptions), options), { enhancedContent: ecSettings });
        var sessionId = 'NOT_TRACKED';
        var pageSessionId = (0, uuid_1.v4)();
        if (this.settings.tracking) {
            sessionId = this.getOrCreateSessionId();
        }
        else {
            this.removeSessionId();
        }
        this.context = {
            url: window.location.href,
            sessionId: sessionId,
            pageSessionId: pageSessionId,
            tracking: this.settings.tracking,
            clientId: this.settings.clientId,
            languageCode: this.settings.languageCode,
            enhancedContent: this.settings.enhancedContent,
            version: version_1.SDK_VERSION,
        };
        (0, enhancedContent_1.attachIframeContextListener)(this.context);
        var logger = (0, logger_1.createLogger)(this.settings.clientId, sessionId, pageSessionId);
        logger.log('init', this.settings);
        var tracker = new time_on_page_tracker_1.default(logger);
        tracker.start();
        this.ecApi = new enhancedContent_1.default(this.settings, logger, { beforeRender: this.resetPageSessionId.bind(this) });
        this.eventsApi = new events_1.default(logger);
        this._initialized = true;
    };
    Object.defineProperty(SdkApi.prototype, "initialized", {
        /**
         * Returns if the SDK has been initialized.
         *
         * **Usage**
         ```javascript
         const salsify = window.salsifyExperiencesSdk;
         salsify.initialized; // false
         salsify.init({ clientId, enhancedContent: { idType } });
         salsify.initialized; // true
         */
        get: function () {
            return this._initialized;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SdkApi.prototype, "enhancedContent", {
        /**
         * Grabs the initialized Enhanced Content API.
         * Throws an error if the SDK has not been initialized.
         *
         * **Usage**
         ```javascript
         const salsify = window.salsifyExperiencesSdk;
         const ec = salsify.enhancedContent;
         ```
         */
        get: function () {
            if (!this.ecApi) {
                throw new Error('Salsify Experiences SDK has not been initialized.');
            }
            return this.ecApi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SdkApi.prototype, "events", {
        /**
         * Grabs the initialized Events API.
         * Throws an error if the SDK has not been initialized.
         *
         * **Usage**
         ```javascript
         const salsify = window.salsifyExperiencesSdk;
         const events = salsify.events;
         ```
         */
        get: function () {
            if (!this.eventsApi) {
                throw new Error('Salsify Experiences SDK has not been initialized.');
            }
            return this.eventsApi;
        },
        enumerable: false,
        configurable: true
    });
    SdkApi.prototype.getOrCreateSessionId = function () {
        var id = (0, cookies_1.getCookie)(sessionIdKey);
        if (!id) {
            id = (0, uuid_1.v4)();
            (0, cookies_1.setCookie)(sessionIdKey, id);
        }
        return id;
    };
    SdkApi.prototype.removeSessionId = function () {
        (0, cookies_1.deleteCookie)(sessionIdKey);
    };
    SdkApi.prototype.resetPageSessionId = function () {
        if (this.context) {
            this.context.pageSessionId = (0, uuid_1.v4)();
        }
    };
    return SdkApi;
}());
exports.default = SdkApi;
//# sourceMappingURL=api.js.map